import React, {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {ProductService} from "../product/Service";
import Select from "react-select";
import {OrderService} from "./Service";
import {useParams} from "react-router";
import {format} from "date-fns";

const UpdateOrder = ({user, refresh}) => {
    const {id} = useParams();
    const [productService] = useState(new ProductService());
    const [orderService] = useState(new OrderService());
    const [loading, setLoading] = useState(false);
    const [order, setOrder] = useState(null);
    const [products, setProducts] = useState([])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

    }


    useEffect(() => {
        const getOrder = async () => {
            const res = await orderService.get(id);
            if (res) {
                setOrder(res);
            }
        }
        getOrder();
    }, []);

    useEffect(() => {
        const fetchProducts = async () => {
            const res = await productService.all();
            if (res) {
                setProducts(res);
            }
        }
        fetchProducts();
    }, []);


    return (
        <>
            <div className="card mb-5">
                <div className="card-header p-3">
                    <h5 className="card-title">Order Details</h5>
                </div>
                {order != null && <div className="card-body m-3">
                    <form onSubmit={handleSubmit}>
                        <div className="p-3 rounded-2 mb-3 row" style={{
                            backgroundColor: '#FDFAE7'
                        }}>
                            <div className="col-sm-12 col-md-8">
                                <h3>#{order['orderId']}</h3>
                                <div>
                                    <span>{order['carts'].length} Products</span> •
                                    <span> Order Placed in {format(Date.parse(order['createdAt']), "dd MMM, yyyy")} at {format(Date.parse(order['createdAt']), "hh:mm")}</span>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 d-flex justify-content-center mt-3">
                                <h3 style={{
                                    color: '#2DA5F3'
                                }}>₹{order['totalAmount']}</h3>
                            </div>
                        </div>
                        <div style={{
                            margin: "30px 0 10px 0"
                        }}>
                            <h5>Products</h5>
                        </div>
                        <div className='table-responsive w-100'>
                            <table
                                id="table"
                                className='table datatable w-100'
                            >
                                <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Product Name</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Sub-Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    order['carts'].map((item, index) => {
                                            return <tr key={index}>
                                                <td>
                                                    <img src={products.find(
                                                        (product) => product['_id'] === item['product']
                                                    ).images[0]} alt={products.find(
                                                        (product) => product['_id'] === item['product']
                                                    ).title}
                                                         style={{
                                                             width: '50px',
                                                             height: '50px'
                                                         }}/>
                                                </td>
                                                <td>{products.find(
                                                    (product) => product['_id'] === item['product']
                                                ).title}</td>
                                                <td>₹{products.find(
                                                    (product) => product['_id'] === item['product']
                                                ).price}</td>
                                                <td>{item['quantity']}</td>
                                                <td>₹{products.find(
                                                    (product) => product['_id'] === item['product']
                                                ).price * item['quantity']}</td>
                                            </tr>
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                        <div style={{
                            margin: "30px 0 10px 0"
                        }}>
                            <h5>Product Custom Details</h5>
                        </div>
                        <div>
                            {order['carts'].map((item, index) => {
                                return <div className="card p-3" key={index} style={{
                                    margin: "10px 0 10px 0"
                                }}>
                                    <div className="d-flex align-items-center">
                                        <img src={products.find(
                                            (product) => product['_id'] === item['product']
                                        ).images[0]} alt={products.find(
                                            (product) => product['_id'] === item['product']
                                        ).title}
                                             style={{
                                                 width: '50px',
                                                 height: '50px',
                                                 marginRight: '10px'
                                             }}/>
                                        <h4>{products.find(
                                            (product) => product['_id'] === item['product']
                                        ).title}</h4>
                                    </div>
                                    <br />
                                    <p><b>Name :- </b>{item['info']['name']}</p>
                                    <p><b>Email :- </b>{item['info']['email']}</p>
                                    <p><b>Designation :- </b>{item['info']['designation']}</p>
                                    <p><b>Phone Number :- </b>{item['info']['phoneNumber']}</p>
                                </div>
                            })}
                        </div>
                        <div style={{
                            margin: "30px 0 10px 0"
                        }}>
                            <h5>Shipping Address</h5>
                            <p>{order['billing']['addressLine1']}</p>
                            <p style={{opacity: '80%'}}>{order['billing']['addressLine2']}</p>
                            <p style={{opacity: '80%'}}>{order['billing']['city']}, {order['billing']['state']} - {order['billing']['postcode']}</p>
                            <p><b>Phone Number :- </b>{order['billing']['phoneNumber']}</p>
                            <p><b>Email :- </b>{order['billing']['email']}</p>
                        </div>


                        <div className={'d-flex'}>
                            <button type="button" className="btn btn-secondary me-2" disabled={loading} onClick={() => {
                                window.history.back();
                            }}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Back
                            </button>
                        </div>

                    </form>

                </div>}
            </div>
        </>
    );
}


export default UpdateOrder;
